@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.web.models.ContactType

data class ContactUsConfigDto(
    val contacts: Array<ContactDto>
)

@Suppress("NON_EXPORTABLE_TYPE")
data class ContactDto(
    val id: Int?,
    val name: String,
    val address: String,
    val imageUrl: String?,
    val link: String?,
    @Suppress("NON_EXPORTABLE_TYPE") val type: DtoName<ContactType>,
)

fun ContactDto.copyX(
    id: Int? = this.id,
    name: String = this.name,
    address: String = this.address,
    imageUrl: String? = this.imageUrl,
    link: String? = this.link,
    @Suppress("NON_EXPORTABLE_TYPE") type: DtoName<ContactType> = this.type,
) = ContactDto(
    id = id,
    name = name,
    address = address,
    imageUrl = imageUrl,
    link = link,
    type = type,
)